import { Routes, RouterModule,  RouteReuseStrategy} from '@angular/router';
import { TmvComponent } from './components/tmv/tmv.component';

export const routes: Routes = [
  { path: '', component: TmvComponent},//data: {shouldReuse: true},
];